"use client";

import heroOne from "@/png/auth/hero_1.png";
import heroTwo from "@/png/auth/hero_2.png";
import heroThree from "@/png/auth/hero_3.png";
import heroFour from "@/png/auth/hero_4.png";
import heroFive from "@/png/auth/hero_5.png";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function Hero() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = [heroOne, heroTwo, heroThree, heroFour, heroFive];
    const SLIDE_INTERVAL = 5000;

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1,
            );
        }, SLIDE_INTERVAL);

        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <section className="relative hidden min-h-dvh items-center justify-center md:flex md:w-1/2">
            {images.map((image, index) => {
                const key = `auth-hero-${index}`;
                return (
                    <Image
                        key={key}
                        src={image}
                        fill
                        priority
                        quality={100}
                        sizes="(min-width: 768px) 50vw, 100vw"
                        className={`pointer-events-none select-none object-contain transition-opacity duration-1000 ${
                            currentImageIndex === index
                                ? "opacity-100"
                                : "opacity-0"
                        }`}
                        alt={`Auth Hero ${index}`}
                    />
                );
            })}
        </section>
    );
}
